import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  classes: PropTypes.shape({
    errMsg: PropTypes.string,
  }).isRequired,
};

const HiddenTextField = props => {
  const {
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    classes,
    ...otherProps
  } = props;

  return (
    <>
      <input
        type="hidden"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        {...otherProps}
      />
      {invalid && touched && <div className={classes.errMsg}>{error}</div>}
    </>
  );
};

HiddenTextField.propTypes = propTypes;

export default withStyles(styles)(HiddenTextField);
